import { gql } from '@apollo/client/core';

export const CREATE_TICKET_CATEGORY_MUTATION = gql`
    mutation CreateCategory($input: CreateTicketCategoryInput!) {
        createTicketCategory(input: $input) {
            id
            name
            priority
            auto_response
            is_active
        }
    }
`;

export const UPDATE_TICKET_CATEGORY_MUTATION = gql`
    mutation UpdateCategory($id: ID!, $name: String, $priority: TicketPriority, $auto_response: String) {
        updateTicketCategory(id: $id, name: $name, priority: $priority, auto_response: $auto_response) {
            id
            name
            priority
            auto_response
            is_active
        }
    }
`;

export const CREATE_TICKET_MUTATION = gql`
    mutation CreateTicket($input: CreateTicketInput!) {
        createTicket(input: $input) {
            id
            subject
            status
            priority
            created_at
        }
    }
`;

export const REPLY_TICKET_MUTATION = gql`
    mutation ReplyTicket($input: ReplyTicketInput!) {
        replyTicket(input: $input) {
            id
            message
             sender {
                ... on User { id name }
                ... on Student { id surname first_name }
            }
             attachments {
                id
                file { url original_name }
            }
            created_at
            scheduled_at
            status
        }
    }
`;

export const UPDATE_TICKET_STATUS_MUTATION = gql`
    mutation UpdateTicketStatus($input: UpdateTicketStatusInput!) {
        updateTicketStatus(input: $input) {
            id
            status
        }
    }
`;
